import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Features from "./sections/Features";
import AboutUs from "./sections/AboutUs";
import OurCare from "./sections/OurCare";
import OurHomes from "./sections/OurHomes";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Features />
      <AboutUs />
      <OurCare />
      <OurHomes />
      <CallToAction />
      <Footer />
    </div>;
}